/*
*###############################################################################
*Module Name                   : InboundCapacityContent.js                     #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath                                 #
*Date                          : Friday, December 01th 2021, 08:35:19 am       #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/MasterUpload.xlsx";
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
import DPTextBoxTow from 'framework/components/DPTextBoxTow'

const InboundCapacityContent = ({
    disabled,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    showFileUpload,
    valueUpload,
    menuCode,
    YearOnChange,
    YearValue,
    WeekValue,
    WeekOnChange,
    MinCapValue,
    MinCapOnChange,
    MaxCapValue,
    MaxCapOnChange,
    MinCapOnBlur,
    MaxCapOnBlur,
    YearOnBlur,
    WeekOnBlur,
    DepValue,
    DepOnChange,
    code,
    codeOnChange,
    codeOnBlur,
    GetSelectCodeRow,
    codeModelTrigger,
    codeModelOpen,
    DepOnBlur,
    autoCode,
    departmentName
}) => {
    //Values from designation context
    //const { val1 } = useContext(Context);

    const [HeadColumns, setHeadColumns] = useState([])
    const [groupFilter, SetGroupFilter] = useState("a")
    const ApiURL = window.Links.ApiURL


    //*** End of useStates */


    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];



    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">

                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Code"
                                            textType="text"
                                            maxLength="50"
                                            value={code}
                                            onChange={codeOnChange}
                                            onBlur={codeOnBlur}
                                            disabled={disabledCode}
                                            placeholder={autoCode}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Button
                                            onClick={() => {
                                                codeModelTrigger()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                            disabled={SearchDisable}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">

                                        <DPTextBoxTow
                                            rowClass="mb-4-sm"
                                            labelText="Department *"
                                            textType="text"
                                            disabled1={disabled}
                                            disabled2={true}
                                            value1={DepValue}
                                            value2={departmentName}
                                            onChange1={DepOnChange}
                                            onBlur1={DepOnBlur}
                                        />


                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Button
                                            onClick={() => {
                                                modelTrigger()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                            disabled={disabled}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Year"
                                            textType="text"
                                            maxLength="4"
                                            value={YearValue}
                                            onChange={YearOnChange}
                                            onBlur={YearOnBlur}
                                            disabled={disabled}
                                        />

                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">

                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Week"
                                            textType="text"
                                            maxLength="50"
                                            value={WeekValue}
                                            onChange={WeekOnChange}
                                            onBlur={WeekOnBlur}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">

                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Min capacity"
                                            textType="text"
                                            maxLength="50"
                                            value={MinCapValue}
                                            onChange={MinCapOnChange}
                                            onBlur={MinCapOnBlur}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">

                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Max capacity"
                                            textType="text"
                                            maxLength="50"
                                            value={MaxCapValue}
                                            onChange={MaxCapOnChange}
                                            onBlur={MaxCapOnBlur}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">

                                    </Col>
                                </Row>










                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">

                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm">
                                <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <input
                                            id="file"
                                            type="file"
                                            onChange={showFileUpload}
                                            value={valueUpload}
                                            disabled={disabledCode}
                                            accept=".xlsx, .xls, .csv"
                                            style={{ display: "none" }}
                                        />

                                        <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                                            <span >
                                                <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                            </span>
                                        </label></li>

                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                                            style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                                            <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                                        </a></li>
                                </ul>
                            </Col>

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={HeadColumns}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={codeModelOpen}
                                toggle={codeModelTrigger}
                                getSelect={GetSelectCodeRow}
                                APIURL={ApiURL}
                                URLPath={"CODE"}
                                MenuCode={menuCode}
                                KeyVal={"COD"}
                                searchBy={"CM_CODE"}
                                FilterStr={groupFilter}
                            />
                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={HeadColumns}
                                defaultSorted={defaultSorted}
                                mainTitle={"Department Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"DEPARTMENT"}
                                MenuCode={menuCode}
                                KeyVal={"DEP"}
                                searchBy={"GP_CODE"}
                                FilterStr={groupFilter}
                            />
                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default InboundCapacityContent